export default __webpack_public_path__ + "media/arrow-ios-down.e006d34c.svg";